// Hook modyfikacji pozycji kalkulacji oferty –
// PUT /sales-crm/clients/:cid/offers/:oid/calculations/:calcId/positions/:positionId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type {
  CalculationPositionPriceType,
  ISalesCrmOfferCalculationPosition
} from 'api/endpoints/useGetSalesCrmOfferCalculationPositions';

export interface IPutSalesCrmOfferCalculationPositionPayload {
  name?: string;
  productId?: number | null;
  serviceId?: number | null;
  priceType?: CalculationPositionPriceType;
  priceNet?: number;
  priceGross?: number | null;
  taxPercent?: number | null;
  /** Koszt własny netto — ile placimy dostawcy/wykonawcy (do realnej marzy). */
  costNet?: number | null;
}

export interface IPutSalesCrmOfferCalculationPositionVariables {
  positionId: number;
  payload: IPutSalesCrmOfferCalculationPositionPayload;
}

export type IPutSalesCrmOfferCalculationPositionResponse = ICommandResponseSuccess &
  Partial<ISalesCrmOfferCalculationPosition>;

const putSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  positionId: number,
  payload: IPutSalesCrmOfferCalculationPositionPayload
): Promise<IPutSalesCrmOfferCalculationPositionResponse> =>
  axios.put(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}/positions/${positionId}`,
    payload
  );

export const usePutSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  options?: UseMutationOptions<
    IPutSalesCrmOfferCalculationPositionResponse,
    IError,
    IPutSalesCrmOfferCalculationPositionVariables
  >
) =>
  useMutation(
    ({ positionId, payload }: IPutSalesCrmOfferCalculationPositionVariables) =>
      putSalesCrmOfferCalculationPosition(clientId, offerId, calculationId, positionId, payload),
    options
  );
